{
  "personalizedDestinations": {
    "title": "Kohteita, joista voisit pitää"
  }
}
